import * as Yup from 'yup';
  
const phoneRegex = /^(?:0|\+[34])[\+\s\-\d]+$/;
const emailRegex = /^[a-zA-Z0-9._-]+[a-zA-Z0-9_-]@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;

Yup.addMethod(Yup.string, 'phone', function validatePhone(message) {
  return this.matches(phoneRegex, {
    message,
    excludeEmptyString: true,
  });
});

Yup.addMethod(Yup.string, 'email', function validateEmail(message) {
  return this.matches(emailRegex, {
    message,
    excludeEmptyString: true,
  });
});

export const getFormValidationSchema = (errorMessages, language) => {
  return Yup.object().shape({
    contact: Yup.object().shape({
      name: Yup.string().trim().max(100, errorMessages.name.tooLong),
      address: Yup.string().trim().max(100, errorMessages.address.tooLong),
      postalCode: Yup.string().trim().max(15, errorMessages.postalCode.tooLong),
      city: Yup.string().trim().max(50, errorMessages.city.tooLong),
      phone: Yup.string()
        .trim()
        .phone(errorMessages.phone.invalid)
        .min(language === 'NO' ? 12 : language === 'FI' ? 9 : 11, errorMessages.phone.tooShort)
        .max(20, errorMessages.phone.tooLong),
      email: Yup.string().trim().email(errorMessages.email.invalid).max(100, errorMessages.email.tooLong),
    }),
  });
};
